import classNames from 'classnames'

import { EMPTY_LIST } from '../../../constants/common'
import Text from '../../Text'

import * as styles from './ChartTooltip.module.css'

function ChartTooltip({
  className = styles.tooltip,
  rows = EMPTY_LIST,
  title,
}) {
  return (
    <span className={className}>
      {title ? (
        <Text isSecondary className={styles.title}>
          {title}
        </Text>
      ) : null}
      {rows.map(row => (
        <span className={styles.row} key={row.id ?? row.label ?? row.value}>
          {row.color ? (
            <span
              className={styles.dot}
              style={{ backgroundColor: row.color }}
            />
          ) : null}
          {row.label ? (
            <Text isSecondary className={styles.text}>
              {row.label}
            </Text>
          ) : null}
          <Text
            isSecondary
            className={classNames(styles.text, {
              [styles.strong]: row.isStrong,
            })}
          >
            {row.value}
          </Text>
        </span>
      ))}
    </span>
  )
}

export default ChartTooltip
